import IntegralTask from './integral-task';
export default IntegralTask;
